import axios from "axios";
import { DEFAULT_EIN, EINS, SET_ERROR } from "../../types"
import ToastMessage from '../../../components/toast';

export const saveDefaultEIN = (payload) => {
    return async (dispatch) => {
        await axios.post(`api/patient-hours/create-default-ein`, payload).then(response => {
            dispatch({
                type: DEFAULT_EIN,
                payload: response.data
            });
            ToastMessage("Successfully submitted", "success");
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            })
        })
    }
}
export const getDefaultEINByCompanyID = (company) => {
    return async (dispatch) => {
        await axios.get(`api/patient-hours/get-default-ein/${company}`).then(response => {
            dispatch({
                type: DEFAULT_EIN,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            })
        })
    }
};

/**
 * 
 * @param {String} id company's _id
 * @returns 
 */
export const GetEins = (id) => {
    return async (dispatch) => {
        await axios.get(`api/patient-hours/get-eins/${id}`).then(response => {
            dispatch({
                type: EINS,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};
